
<template  minapp='mpx' xlang='wxml'>
  <controllable-drawer-bottom
    title="请登录12306"
    show="{{show}}"
    headerStyle="{{headerStyle}}"
    iconStyle="{{iconStyle}}"
    bind:close="closeLoginDrawer"
  >
    <view class="card">
      <view class="card-description">铁路部门规定购买火车票需实名认证</view>
      <view class="button-group">
        <login-drawer-button 
          class="button" 
          buttonType="{{1}}" 
          amount="{{offlineAmount}}"
          bind:close="closeLoginDrawer" 
          bindcheck="check" 
          bindsubmit="submit"/>
        <login-drawer-button 
          class="button"
          amount="{{login12306Amount}}"
          bind:close="closeLoginDrawer" 
          bindcheck="check"/>
      </view>
    </view>
  </controllable-drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { DeadLineList } from '@/utils/constants'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false,
      },
      offlineAmount:{
        type: Number,
        value: 0
      },
      login12306Amount:{
        type: Number,
        value: 0
      }
    },
    attached() {},
    computed: {},
    data: {
      headerStyle: {
        'justify-content': 'flex-start',
        'padding-left': '20px',
        'padding-top': '24px',
        'font-family': 'PingFangSC-Medium',
        'font-size': '18px',
        'line-height': '18px',
        color: '#000000',
      },
      iconStyle: {
        top: '20px',
      },
    },
    methods: {
      closeLoginDrawer() {
        this.triggerEvent('close')
      },
      check() {
        this.triggerEvent('check')
      },
      submit() {
        this.triggerEvent('submit')
      }
    },
  })
</script>

<style lang='stylus' scoped>
  .card
    margin-top 10px
    display flex
    flex-direction column
    padding 0 20px 49px 20px
    &-description
      font-family PingFangSC-Regular
      font-size 12px
      line-height 18px
      color #999999
      margin-bottom 16px
    .button-group
      display flex
      justify-content space-between
      .button 
        flex 1
        &:not(:last-child)
          margin-right 12px
</style>

  
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'controllable-drawer-bottom': '@/components/controllable-drawer-buttom',
      'login-drawer-button': './login-drawer-button',
    },
  }
</script>